import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.manual');
import { OnInit, OnDestroy, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import showdown from 'showdown';

const AGENT_STORAGE_PREFIX = 'gsdc-manual-floating-agent';
const AGENT_WELCOME = '안녕하세요. 현재 보고 있는 GSDC 매뉴얼 화면을 기준으로 필요한 내용을 찾아드릴게요.';

@Component({
    selector: 'wiz-portal-gsdcuser-manual',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.manual/view.scss */
:host {
  --manual-bg: #ffffff;
  --manual-panel: #f7f9fc;
  --manual-text: #263c55;
  --manual-title: #172f4d;
  --manual-muted: #65788f;
  --manual-line: #e5ebf3;
  --manual-accent: #175d9c;
  --manual-selected: #eaf2fb;
  --manual-code: #f1f5fa;
  --manual-mark: #fff0b5;
  --manual-mark-text: #714b08;
  display: block;
  width: 100%;
  height: calc(100dvh - 144px);
  min-height: 420px;
  container-type: inline-size;
}

:host-context(html.dark) {
  --manual-bg: #172537;
  --manual-panel: #142133;
  --manual-text: #cfdaea;
  --manual-title: #edf3fb;
  --manual-muted: #9caec4;
  --manual-line: #2b3c52;
  --manual-accent: #8bc8fa;
  --manual-selected: #203c59;
  --manual-code: #102034;
  --manual-mark: #624c20;
  --manual-mark-text: #ffedaa;
}

.manual-docs {
  display: grid;
  grid-template-columns: 224px minmax(0, 1fr) 180px;
  height: 100%;
  min-height: 0;
  background: var(--manual-bg);
  color: var(--manual-text);
  border: 1px solid var(--manual-line);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(23, 55, 89, 0.0156862745);
}

.manual-mobile-toggle, .manual-sidebar-close, .manual-inline-outline {
  display: none;
}

.manual-sidebar {
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  border-right: 1px solid var(--manual-line);
  background: var(--manual-panel);
}

.manual-sidebar-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 20px 16px 14px;
}

.manual-sidebar-title {
  display: flex;
  align-items: center;
  gap: 9px;
  font-size: 13px;
  font-weight: 700;
  color: var(--manual-title);
}

.manual-sidebar-title i {
  color: var(--manual-accent);
  font-size: 13px;
}

.manual-search {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 12px 14px;
}

.manual-search > i {
  position: absolute;
  left: 23px;
  color: var(--manual-muted);
  font-size: 12px;
  pointer-events: none;
}

.manual-search-input {
  width: 100%;
  height: 38px;
  padding: 0 30px 0 30px;
  border: 1px solid var(--manual-line);
  border-radius: 8px;
  background: var(--manual-bg);
  color: var(--manual-text);
  font-size: 12px;
}

.manual-search-input::placeholder {
  color: var(--manual-muted);
  opacity: 1;
}

.manual-search-clear {
  position: absolute;
  right: 17px;
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 5px;
  background: transparent;
  color: var(--manual-muted);
}

.manual-tree {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0 8px 20px;
  scrollbar-width: thin;
}

.manual-tree-row {
  position: relative;
  width: 100%;
  min-height: 38px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 2px 0;
  padding: 8px 10px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--manual-text);
  cursor: pointer;
  font-size: 13px;
  line-height: 1.5;
  text-align: left;
  transition: background 0.15s, color 0.15s;
}

.manual-tree-row:hover, .manual-search-clear:hover {
  background: var(--manual-selected);
  color: var(--manual-accent);
}

.manual-tree-row.is-active {
  background: var(--manual-selected);
  color: var(--manual-accent);
  font-weight: 650;
}

.manual-tree-row.is-active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 10px;
  bottom: 10px;
  width: 3px;
  border-radius: 3px;
  background: var(--manual-accent);
}

.manual-tree-label {
  min-width: 0;
  overflow: hidden;
  overflow-wrap: anywhere;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.manual-caret, .manual-folder-icon, .manual-file-icon {
  flex-shrink: 0;
  color: var(--manual-muted);
  font-size: 12px;
}

.manual-caret {
  width: 9px;
  font-size: 9px;
  transition: transform 0.15s;
}

.manual-caret.is-open {
  transform: rotate(90deg);
}

.manual-tree-row.is-active .manual-file-icon {
  color: var(--manual-accent);
}

.manual-tree-match {
  padding: 0 1px;
  border-radius: 2px;
  background: var(--manual-mark);
  color: var(--manual-mark-text);
}

.manual-content {
  min-width: 0;
  min-height: 0;
  overflow: auto;
  background: var(--manual-bg);
  scrollbar-width: thin;
}

.manual-article {
  max-width: 820px;
  margin: 0 auto;
  padding: 30px 28px 80px;
}

.manual-document-path {
  margin-bottom: 14px;
  color: var(--manual-muted);
  font-size: 12px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.manual-article-title {
  margin: 0 0 24px;
  padding: 0 0 20px;
  border-bottom: 1px solid var(--manual-line);
  color: var(--manual-title);
  font-size: 28px;
  font-weight: 750;
  line-height: 1.4;
  letter-spacing: -0.035em;
  overflow-wrap: anywhere;
}

.manual-state {
  min-height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  color: var(--manual-muted);
  font-size: 14px;
  text-align: center;
}

.manual-state.is-error {
  flex-direction: column;
  gap: 16px;
  color: var(--manual-text);
}

.manual-retry {
  padding: 9px 18px;
  border: 1px solid var(--manual-line);
  border-radius: 8px;
  background: var(--manual-selected);
  color: var(--manual-accent);
  font-size: 13px;
  font-weight: 650;
}

.manual-empty {
  padding: 24px 12px;
  color: var(--manual-muted);
  font-size: 13px;
  line-height: 1.7;
}

.manual-on-this-page {
  min-width: 0;
  min-height: 0;
  overflow: auto;
  padding: 30px 14px;
  border-left: 1px solid var(--manual-line);
  background: var(--manual-bg);
  scrollbar-width: thin;
}

.manual-on-title {
  margin: 0 0 16px 10px;
  color: var(--manual-title);
  font-size: 12px;
  font-weight: 700;
}

.manual-on-empty {
  padding-left: 10px;
  color: var(--manual-muted);
  font-size: 12px;
}

.manual-on-link {
  display: block;
  width: 100%;
  padding: 7px 10px;
  border: 0;
  border-left: 2px solid var(--manual-line);
  background: transparent;
  color: var(--manual-muted);
  cursor: pointer;
  font-size: 13px;
  line-height: 1.55;
  text-align: left;
  overflow-wrap: anywhere;
}

.manual-on-link:hover {
  color: var(--manual-accent);
  background: var(--manual-panel);
}

.manual-on-link.is-active {
  color: var(--manual-accent);
  background: var(--manual-selected);
  border-left-color: var(--manual-accent);
  font-weight: 650;
}

.manual-on-link.is-sub {
  padding-left: 16px;
}

.manual-on-link.is-deep {
  padding-left: 24px;
}

.manual-toggle-caret {
  margin-left: auto;
  font-size: 10px;
  transition: transform 0.15s;
}

.manual-toggle-caret.is-open, details[open] .manual-toggle-caret {
  transform: rotate(180deg);
}

:host ::ng-deep .manual-article .markdown-body {
  color: var(--manual-text) !important;
  background: transparent;
  font-size: 15px;
  line-height: 1.85;
  overflow-wrap: anywhere;
}
:host ::ng-deep .manual-article .markdown-body h1, :host ::ng-deep .manual-article .markdown-body h2, :host ::ng-deep .manual-article .markdown-body h3, :host ::ng-deep .manual-article .markdown-body h4, :host ::ng-deep .manual-article .markdown-body h5, :host ::ng-deep .manual-article .markdown-body h6 {
  color: var(--manual-title) !important;
  line-height: 1.5;
  font-weight: 700;
  letter-spacing: -0.025em;
  scroll-margin-block: 20px;
}
:host ::ng-deep .manual-article .markdown-body h1 {
  margin: 32px 0 22px;
  padding-bottom: 18px;
  border-bottom: 1px solid var(--manual-line);
  font-size: 28px;
}
:host ::ng-deep .manual-article .markdown-body > h1:first-child {
  margin-top: 0;
  font-weight: 750;
  line-height: 1.4;
  letter-spacing: -0.035em;
}
:host ::ng-deep .manual-article .markdown-body h2 {
  margin: 36px 0 14px;
  padding-bottom: 10px;
  border-bottom: 1px solid var(--manual-line);
  font-size: 21px;
}
:host ::ng-deep .manual-article .markdown-body h3 {
  margin: 28px 0 12px;
  font-size: 17px;
}
:host ::ng-deep .manual-article .markdown-body h4, :host ::ng-deep .manual-article .markdown-body h5, :host ::ng-deep .manual-article .markdown-body h6 {
  margin: 24px 0 10px;
  font-size: 15px;
}
:host ::ng-deep .manual-article .markdown-body p {
  margin: 0 0 16px;
}
:host ::ng-deep .manual-article .markdown-body ul, :host ::ng-deep .manual-article .markdown-body ol {
  margin: 12px 0 20px;
  padding-left: 24px;
}
:host ::ng-deep .manual-article .markdown-body li {
  margin: 6px 0;
}
:host ::ng-deep .manual-article .markdown-body li > p {
  margin-bottom: 8px;
}
:host ::ng-deep .manual-article .markdown-body a {
  color: var(--manual-accent) !important;
  text-decoration: underline;
  text-decoration-color: color-mix(in srgb, var(--manual-accent) 40%, transparent);
  text-underline-offset: 3px;
}
:host ::ng-deep .manual-article .markdown-body strong {
  color: var(--manual-title) !important;
  font-weight: 650;
}
:host ::ng-deep .manual-article .markdown-body code {
  padding: 3px 6px;
  border-radius: 5px;
  background: var(--manual-code) !important;
  color: var(--manual-accent) !important;
  font-size: 0.88em;
}
:host ::ng-deep .manual-article .markdown-body pre {
  max-width: 100%;
  margin: 20px 0;
  padding: 18px;
  border: 1px solid var(--manual-line);
  border-radius: 9px;
  background: var(--manual-code) !important;
  color: var(--manual-text) !important;
  font-size: 13px;
  line-height: 1.8;
  overflow: auto;
  overflow-wrap: normal;
}
:host ::ng-deep .manual-article .markdown-body pre code {
  padding: 0;
  border: 0;
  background: transparent !important;
  color: inherit !important;
  font-size: inherit;
  white-space: pre;
}
:host ::ng-deep .manual-article .markdown-body table {
  display: block;
  max-width: 100%;
  width: max-content;
  margin: 22px 0;
  overflow-x: auto;
  border-collapse: collapse;
  font-size: 14px;
}
:host ::ng-deep .manual-article .markdown-body th, :host ::ng-deep .manual-article .markdown-body td {
  padding: 10px 14px;
  border: 1px solid var(--manual-line) !important;
  background: var(--manual-bg);
  color: var(--manual-text);
  line-height: 1.7;
}
:host ::ng-deep .manual-article .markdown-body th {
  background: var(--manual-panel) !important;
  color: var(--manual-title);
  font-weight: 650;
}
:host ::ng-deep .manual-article .markdown-body tr {
  background: transparent;
  border: 0;
}
:host ::ng-deep .manual-article .markdown-body blockquote {
  margin: 20px 0;
  padding: 14px 18px;
  border: 0;
  border-left: 3px solid var(--manual-accent) !important;
  border-radius: 0 8px 8px 0;
  background: var(--manual-panel);
  color: var(--manual-text) !important;
}
:host ::ng-deep .manual-article .markdown-body blockquote > :last-child {
  margin-bottom: 0;
}
:host ::ng-deep .manual-article .markdown-body hr {
  margin: 28px 0;
  height: 1px;
  border: 0;
  background: var(--manual-line);
}
:host ::ng-deep .manual-article .markdown-body img {
  display: block;
  box-sizing: border-box;
  max-width: 100%;
  height: auto;
  margin: 20px auto;
  border: 1px solid var(--manual-line);
  border-radius: 8px;
  background: transparent;
}
:host ::ng-deep .manual-article .markdown-body .manual-content-match {
  padding: 0 2px;
  border-radius: 3px;
  background: var(--manual-mark);
  color: var(--manual-mark-text);
  box-shadow: none;
}

.manual-docs button:focus-visible, .manual-docs input:focus-visible, .manual-docs summary:focus-visible {
  outline: 2px solid var(--manual-accent);
  outline-offset: -2px;
}

@container (max-width: 960px) {
  .manual-docs {
    grid-template-columns: 224px minmax(0, 1fr);
  }
  .manual-on-this-page {
    display: none;
  }
  .manual-inline-outline {
    display: block;
    border-bottom: 1px solid var(--manual-line);
    background: var(--manual-bg);
  }
  .manual-inline-outline summary {
    display: flex;
    align-items: center;
    gap: 9px;
    min-height: 46px;
    padding: 10px 24px;
    color: var(--manual-muted);
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    list-style: none;
  }
  .manual-inline-outline summary::-webkit-details-marker {
    display: none;
  }
  .manual-inline-outline nav {
    max-height: 240px;
    overflow: auto;
    padding: 0 24px 16px;
  }
  .manual-article {
    padding-left: 24px;
    padding-right: 24px;
  }
}
@container (max-width: 660px) {
  .manual-docs {
    display: flex;
    flex-direction: column;
  }
  .manual-mobile-toggle {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 9px;
    width: 100%;
    min-height: 46px;
    padding: 12px 20px;
    border: 0;
    border-bottom: 1px solid var(--manual-line);
    background: var(--manual-panel);
    color: var(--manual-title);
    font-size: 13px;
    font-weight: 650;
  }
  .manual-sidebar {
    display: none;
    flex-shrink: 0;
    border-right: 0;
    border-bottom: 1px solid var(--manual-line);
  }
  .manual-sidebar.is-open {
    display: flex;
    max-height: 280px;
  }
  .manual-sidebar-head {
    display: none;
  }
  .manual-search {
    padding-top: 12px;
  }
  .manual-content {
    flex: 1;
  }
  .manual-article {
    padding: 24px 20px 80px;
  }
  .manual-article-title {
    font-size: 24px;
  }
  .manual-inline-outline summary {
    padding-inline: 20px;
  }
  :host ::ng-deep .manual-article .markdown-body h1 {
    font-size: 24px;
  }
  :host ::ng-deep .manual-article .markdown-body h2 {
    font-size: 20px;
  }
}
@media (max-width: 767px) {
  :host {
    height: auto;
    min-height: 0;
  }
  .manual-docs {
    height: auto;
    min-height: 540px;
  }
  .manual-content {
    overflow: visible;
  }
}
@media (prefers-reduced-motion: reduce) {
  .manual-tree-row, .manual-caret, .manual-toggle-caret {
    transition: none;
  }
}
.manual-agent-fab {
  position: fixed;
  right: 28px;
  bottom: 28px;
  z-index: 80;
  width: 54px;
  height: 54px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  background: #2563eb;
  color: #ffffff;
  cursor: pointer;
  box-shadow: 0 16px 34px rgba(37, 99, 235, 0.32);
  transition: transform 140ms ease, background 140ms ease, box-shadow 140ms ease;
}

.manual-agent-fab:hover {
  transform: translateY(-2px);
  background: #1d4ed8;
  box-shadow: 0 18px 38px rgba(29, 78, 216, 0.36);
}

.manual-agent-fab.is-open {
  background: #0f172a;
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.28);
}

.manual-agent-fab i {
  font-size: 20px;
}

.manual-agent-window {
  position: fixed;
  right: 28px;
  bottom: 94px;
  z-index: 79;
  width: min(444px, 100vw - 36px);
  height: min(640px, 100vh - 122px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #dbe3ef;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 24px 58px rgba(15, 23, 42, 0.24);
}

.manual-agent-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  border-bottom: 1px solid #e5e7eb;
  background: #ffffff;
}

.manual-agent-title {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.manual-agent-avatar {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #e0f2fe;
  color: #0369a1;
}

.manual-agent-title-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.manual-agent-title-text strong {
  color: #0f172a;
  font-size: 13px;
  font-weight: 750;
}

.manual-agent-title-text span {
  max-width: 270px;
  overflow: hidden;
  color: #64748b;
  font-size: 11px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.manual-agent-head-actions {
  display: flex;
  align-items: center;
  gap: 4px;
}

.manual-agent-icon-button {
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  cursor: pointer;
}

.manual-agent-icon-button:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.manual-agent-skills {
  display: flex;
  gap: 6px;
  padding: 10px 12px;
  border-bottom: 1px solid #e5e7eb;
  background: #f8fafc;
}

.manual-agent-skill-chip {
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 9px;
  border: 1px solid #dbe3ef;
  border-radius: 999px;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  font-size: 12px;
  font-weight: 650;
}

.manual-agent-skill-chip.is-active {
  border-color: #93c5fd;
  background: #eff6ff;
  color: #1d4ed8;
}

.manual-agent-body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 14px;
  background: #f8fafc;
}

.manual-agent-message {
  position: relative;
  display: flex;
  margin-bottom: 12px;
}

.manual-agent-message.is-user {
  justify-content: flex-end;
}

.manual-agent-message.is-assistant {
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
}

.manual-agent-bubble {
  position: relative;
  min-width: 0;
  max-width: 86%;
  overflow: hidden;
  padding: 11px 12px;
  border-radius: 8px;
  background: #ffffff;
  color: #1f2937;
  font-size: 13px;
  line-height: 1.55;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);
}

.manual-agent-message.is-user .manual-agent-bubble {
  background: #2563eb;
  color: #ffffff;
}

.manual-agent-tool-line {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 7px;
  padding: 3px 7px;
  border-radius: 999px;
  background: #ecfdf5;
  color: #047857;
  font-size: 11px;
  font-weight: 700;
}

.manual-agent-markdown {
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.manual-agent-markdown * {
  max-width: 100%;
}

.manual-agent-markdown h1,
.manual-agent-markdown h2,
.manual-agent-markdown h3 {
  margin: 9px 0 6px;
  color: inherit;
  font-size: 14px;
  line-height: 1.35;
  font-weight: 750;
}

.manual-agent-markdown p {
  margin: 6px 0;
}

.manual-agent-markdown ul,
.manual-agent-markdown ol {
  margin: 6px 0;
  padding-left: 19px;
}

.manual-agent-markdown li {
  margin: 3px 0;
}

.manual-agent-markdown code {
  overflow-wrap: anywhere;
  word-break: break-word;
  padding: 1px 4px;
  border-radius: 4px;
  background: #e0e7ff;
  color: #3730a3;
  font-size: 12px;
}

.manual-agent-markdown pre {
  max-width: 100%;
  margin: 8px 0;
  padding: 10px;
  overflow-x: auto;
  border-radius: 6px;
  background: #0f172a;
  color: #e2e8f0;
  white-space: pre-wrap;
  word-break: break-word;
}

.manual-agent-markdown table {
  display: block;
  overflow-x: auto;
  max-width: 100%;
}

.manual-agent-markdown a {
  overflow-wrap: anywhere;
}

.manual-agent-message.is-user .manual-agent-markdown code {
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
}

.manual-agent-typing {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-height: 20px;
}

.manual-agent-typing span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #60a5fa;
  animation: manualAgentTyping 1.2s ease-in-out infinite;
}

.manual-agent-typing span:nth-child(2) {
  animation-delay: 0.15s;
}

.manual-agent-typing span:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes manualAgentTyping {
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.42;
  }
  30% {
    transform: translateY(-5px);
    opacity: 1;
  }
}
.manual-agent-source-list,
.manual-agent-action-list,
.manual-agent-suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 9px;
}

.manual-agent-source,
.manual-agent-action,
.manual-agent-suggestion,
.manual-agent-quick-button {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-height: 26px;
  padding: 5px 8px;
  border: 1px solid #dbe3ef;
  border-radius: 999px;
  background: #ffffff;
  color: #1d4ed8;
  cursor: pointer;
  font-size: 11px;
  font-weight: 650;
}

.manual-agent-action {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #047857;
}

.manual-agent-source:hover,
.manual-agent-suggestion:hover,
.manual-agent-quick-button:hover {
  border-color: #93c5fd;
  background: #eff6ff;
}

.manual-agent-action:hover {
  border-color: #86efac;
  background: #dcfce7;
}

.manual-agent-copy {
  position: absolute;
  top: 7px;
  right: 7px;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.8);
  color: #94a3b8;
  cursor: pointer;
  opacity: 0;
  transition: opacity 120ms ease;
}

.manual-agent-bubble:hover .manual-agent-copy {
  opacity: 1;
}

.manual-agent-quick {
  display: grid;
  gap: 7px;
  margin-top: 4px;
}

.manual-agent-followups {
  width: 86%;
  margin-top: -4px;
  margin-bottom: 12px;
}

.manual-agent-quick-button {
  justify-content: flex-start;
  border-radius: 7px;
  color: #334155;
  text-align: left;
  line-height: 1.35;
  white-space: normal;
  overflow-wrap: anywhere;
}

.manual-agent-q {
  flex: 0 0 auto;
  color: #1d4ed8;
  font-weight: 750;
}

.manual-agent-status {
  padding: 7px 12px;
  border-top: 1px solid #e5e7eb;
  background: #f8fafc;
  color: #047857;
  font-size: 11px;
  font-weight: 650;
}

.manual-agent-input {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  padding: 10px 12px;
  border-top: 1px solid #e5e7eb;
  background: #ffffff;
}

.manual-agent-textarea {
  flex: 1;
  min-height: 38px;
  max-height: 112px;
  padding: 9px 11px;
  border: 1px solid #dbe3ef;
  border-radius: 7px;
  background: #f8fafc;
  color: #111827;
  resize: none;
  outline: none;
  font-size: 13px;
  line-height: 1.4;
}

.manual-agent-textarea:focus {
  border-color: #93c5fd;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.manual-agent-send {
  width: 38px;
  height: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 7px;
  background: #2563eb;
  color: #ffffff;
  cursor: pointer;
}

.manual-agent-send:hover {
  background: #1d4ed8;
}

.manual-agent-send:disabled {
  background: #cbd5e1;
  cursor: default;
}

.manual-agent-send.is-stop {
  background: #dc2626;
}

.manual-agent-body::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.manual-agent-body::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #cbd5e1;
}

.manual-agent-window,
.manual-agent-window * {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.manual-agent-window *::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.manual-agent-window *::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #cbd5e1;
}

.manual-agent-window *::-webkit-scrollbar-track {
  background: transparent;
}

@media (max-width: 640px) {
  .manual-agent-fab {
    right: 16px;
    bottom: 16px;
    width: 50px;
    height: 50px;
  }
  .manual-agent-window {
    right: 12px;
    bottom: 76px;
    width: calc(100vw - 24px);
    height: min(620px, 100vh - 96px);
  }
  .manual-agent-title-text span {
    max-width: 210px;
  }
  .manual-agent-skills {
    overflow-x: auto;
  }
  .manual-agent-bubble {
    max-width: 92%;
  }
}`],
})
export class PortalGsdcuserManualComponent implements OnInit, OnDestroy {
    @ViewChild('markdownBody') markdownBody: ElementRef;
    @ViewChild('agentChatScroll') agentChatScroll: ElementRef;
    @ViewChild('agentInputArea') agentInputArea: ElementRef;

    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef    )         private cdr: ChangeDetectorRef    ) {}

    public docs: any[] = [];
    public filteredDocs: any[] = [];
    public treeSearch: string = '';
    public selectedPath: string = '';
    public selectedTitle: string = '';
    public hasDocumentTitle: boolean = false;

    public get displayTitle(): string {
        return this.selectedTitle.replace(/\.(md|rst|txt)$/i, '');
    }

    public get documentFolder(): string {
        return this.selectedPath.split('/').slice(0, -1).join(' / ');
    }
    public htmlContent: string = '';
    public docContent: string = '';
    public docMode: string = 'markdown';
    public headings: any[] = [];
    public expanded: any = {};
    public sidebarOpen: boolean = false;
    public loading: boolean = false;
    public treeLoading = false;
    public retryTarget: 'tree' | 'document' | null = null;
    public message: string = '';
    public activeHeadingId: string = '';

    public agentOpen: boolean = false;
    public agentMessages: any[] = [];
    public agentInput: string = '';
    public agentLoading: boolean = false;
    public agentStatus: string = '';
    public agentManifest: any = null;
    public agentSkills: any[] = [
        { name: 'manual-rag-answer', display_name: '매뉴얼 답변', description: '매뉴얼 내용을 검색해 근거 중심으로 답변합니다.' },
        { name: 'manual-page-navigator', display_name: '화면 이동', description: '답변과 함께 관련 매뉴얼 화면을 자동으로 열어줍니다.' }
    ];
    public agentSelectedSkill: string = 'manual-page-navigator';
    public agentQuickQuestions: string[] = [
        '헬프데스크 서비스 안내해줘',
        'HTCondor 사용법 알려줘',
        '데이터 전송 방법이 궁금해',
        '매뉴얼 목록 보여줘'
    ];

    private converter: any;
    private agentAbortCtrl: AbortController | null = null;
    private agentMarkdownCache: Map<string, string> = new Map();
    private destroyed: boolean = false;
    private requestVersion = 0;
    private outlineFrame = 0;
    private navigationFrame = 0;
    private outlineNavigation: { id: string; root?: HTMLElement; settled?: number } | null = null;
    private interruptOutline = (event: Event) => {
        if (event instanceof KeyboardEvent && !['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) return;
        if (!this.outlineNavigation) return;
        this.stopOutlineNavigation(true);
        this.queueOutline();
    };
    private queueOutline = () => {
        if (this.destroyed || this.outlineFrame) return;
        this.outlineFrame = window.requestAnimationFrame(() => {
            this.outlineFrame = 0;
            this.updateActiveHeading();
        });
    };

    public async ngOnInit() {
        await this.service.init();
        this.converter = new showdown.Converter({
            tables: true,
            ghCodeBlocks: true,
            tasklists: true,
            strikethrough: true,
            simplifiedAutoLink: true,
            literalMidWordUnderscores: true
        });
        document.addEventListener('scroll', this.queueOutline, { capture: true, passive: true });
        document.addEventListener('load', this.queueOutline, true);
        window.addEventListener('resize', this.queueOutline);
        for (const event of ['wheel', 'touchstart', 'pointerdown', 'keydown']) {
            document.addEventListener(event, this.interruptOutline, { capture: true, passive: true });
        }
        await this.loadTree();
        await this.service.render();
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.requestVersion++;
        document.removeEventListener('scroll', this.queueOutline, true);
        document.removeEventListener('load', this.queueOutline, true);
        window.removeEventListener('resize', this.queueOutline);
        window.cancelAnimationFrame(this.outlineFrame);
        this.stopOutlineNavigation(true);
        for (const event of ['wheel', 'touchstart', 'pointerdown', 'keydown']) {
            document.removeEventListener(event, this.interruptOutline, true);
        }
        if (this.agentAbortCtrl) this.agentAbortCtrl.abort();
        const context = (window as any).GSDC_MANUAL_CONTEXT;
        if (context && context.path === this.selectedPath) {
            delete (window as any).GSDC_MANUAL_CONTEXT;
            delete (window as any).GSDC_MANUAL_OPEN_DOCUMENT;
        }
    }

    public async loadTree() {
        if (this.treeLoading || this.destroyed) return;
        const version = ++this.requestVersion;
        this.treeLoading = true;
        this.message = '';
        this.retryTarget = null;
        await this.service.render();
        let target: any;
        try {
            const res = await wiz.call('tree');
            if (this.destroyed || version !== this.requestVersion) return;
            if (res.code !== 200 || !Array.isArray(res.data)) throw new Error('tree');
            this.docs = res.data;
            this.applyTreeFilter();
            const requested = this.requestedAgentDocument();
            target = requested ? this.findDocByCandidates(this.docs, [requested]) : this.findFirstFile(this.docs);
            if (requested && !target) {
                this.message = '선택한 문서를 찾을 수 없습니다. 문서 목록에서 다시 선택해주세요.';
                this.retryTarget = 'tree';
            }
        } catch {
            if (this.destroyed || version !== this.requestVersion) return;
            this.message = '매뉴얼 목록을 불러올 수 없습니다.';
            this.retryTarget = 'tree';
        } finally {
            if (!this.destroyed && version === this.requestVersion) {
                this.treeLoading = false;
                await this.service.render();
            }
        }
        if (this.destroyed || version !== this.requestVersion) return;
        if (target) await this.selectDoc(target);
    }

    public async retryLoad() {
        if (this.loading || this.treeLoading) return;
        if (this.retryTarget === 'tree') await this.loadTree();
        else if (this.retryTarget === 'document') {
            await this.selectDoc({ type: 'file', path: this.selectedPath, title: this.selectedTitle });
        }
    }

    public async updateTreeSearch() {
        this.applyTreeFilter();
        if (this.docContent) this.renderContent(this.docContent, this.docMode);
        await this.service.render();
        this.scheduleContentHighlight();
    }

    public async clearTreeSearch() {
        this.treeSearch = '';
        this.applyTreeFilter();
        if (this.docContent) this.renderContent(this.docContent, this.docMode);
        await this.service.render();
        this.scheduleContentHighlight();
    }

    public async selectDoc(item: any) {
        if (!item || item.type !== 'file' || this.treeLoading || this.destroyed) return;
        this.stopOutlineNavigation(true);
        const version = ++this.requestVersion;
        this.selectedPath = item.path;
        this.selectedTitle = item.title;
        this.expandParents(item.path);
        this.sidebarOpen = false;
        this.loading = true;
        this.message = '';
        this.retryTarget = null;
        this.headings = [];
        this.activeHeadingId = '';
        this.docContent = this.htmlContent = '';
        this.updateAgentContext();
        await this.service.render();
        try {
            const res = await wiz.call('load', { path: item.path });
            if (this.destroyed || version !== this.requestVersion) return;
            if (res.code !== 200 || !res.data || typeof res.data.content !== 'string'
                || typeof res.data.path !== 'string' || !res.data.path
                || typeof res.data.title !== 'string') throw new Error('load');
            this.selectedPath = res.data.path;
            this.selectedTitle = res.data.title;
            this.docContent = res.data.content;
            this.docMode = res.data.mode || 'markdown';
            this.renderContent(this.docContent, this.docMode);
            // Reuse the existing deep-link parameter without adding history entries.
            const url = new URL(window.location.href);
            url.searchParams.set('agent_doc', this.selectedPath);
            window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
            this.updateAgentContext();
        } catch {
            if (this.destroyed || version !== this.requestVersion) return;
            this.message = '문서를 불러올 수 없습니다.';
            this.retryTarget = 'document';
        } finally {
            if (!this.destroyed && version === this.requestVersion) {
                this.loading = false;
                await this.service.render();
                this.scheduleContentHighlight();
                this.queueOutline();
            }
        }
    }

    private readingScroller(): HTMLElement {
        let node = this.markdownBody?.nativeElement?.parentElement;
        while (node) {
            if (/(auto|scroll)/.test(getComputedStyle(node).overflowY) && node.scrollHeight > node.clientHeight + 1) return node;
            node = node.parentElement;
        }
        return document.documentElement;
    }

    private updateActiveHeading() {
        if (this.loading || this.treeLoading || !this.headings.length || !this.markdownBody?.nativeElement) return;
        const navigation = this.outlineNavigation;
        if (navigation) {
            // Keep the clicked item highlighted while travelling and at the destination.
            // A later scroll (including a scrollbar drag) resumes position tracking.
            if (navigation.settled === undefined || Math.abs(navigation.root!.scrollTop - navigation.settled) < 1) return;
            this.stopOutlineNavigation(false);
        }
        const body = this.markdownBody.nativeElement as HTMLElement;
        const root = this.readingScroller();
        const rootRect = root === document.documentElement ? { top: 0, bottom: window.innerHeight } : root.getBoundingClientRect();
        const top = Math.max(0, rootRect.top) + 28;
        const nodes = body.querySelectorAll('h1, h2, h3');
        let active = this.headings[0].id;
        for (const heading of this.headings) {
            if (nodes[heading.index]?.getBoundingClientRect().top <= top) active = heading.id;
        }
        if (root.scrollHeight > root.clientHeight + 1 && root.scrollTop > 0
            && body.getBoundingClientRect().bottom <= Math.min(window.innerHeight, rootRect.bottom) + 2) {
            active = this.headings[this.headings.length - 1].id;
        }
        if (this.activeHeadingId !== active) {
            this.activeHeadingId = active;
            this.cdr.detectChanges();
        }
    }

    public async toggleFolder(item: any) {
        this.expanded[item.path] = !this.expanded[item.path];
        await this.service.render();
    }

    public async scrollToHeading(id: string) {
        this.stopOutlineNavigation(true);
        const navigation = { id };
        this.outlineNavigation = navigation;
        this.activeHeadingId = id;
        await this.service.render();
        window.setTimeout(() => {
            if (!this.destroyed && this.outlineNavigation === navigation) this.scrollManualTo(id);
        });
    }

    private stopOutlineNavigation(stopScroll: boolean) {
        const root = this.outlineNavigation?.root;
        this.outlineNavigation = null;
        window.cancelAnimationFrame(this.navigationFrame);
        this.navigationFrame = 0;
        if (stopScroll && root) root.scrollTo({ top: root.scrollTop, behavior: 'instant' });
    }

    public async toggleAgent() {
        this.agentOpen = !this.agentOpen;
        await this.service.render();
        if (this.agentOpen) {
            window.setTimeout(() => {
                this.scrollAgentToBottom();
                this.focusAgentInput();
            });
        }
    }

    public async closeAgent() {
        this.agentOpen = false;
        await this.service.render();
    }

    public async loadAgentManifest() {
        try {
            const res = await wiz.call('agent_manifest');
            if (res.code === 200) {
                this.agentManifest = res.data;
                this.agentSkills = res.data?.skills || this.agentSkills;
                if (!this.agentSelectedSkill && this.agentSkills.length > 0) {
                    this.agentSelectedSkill = this.agentSkills[0].name;
                }
            }
        } catch (error) {}
    }

    public async selectAgentSkill(skill: any) {
        if (!skill || this.agentLoading) return;
        this.agentSelectedSkill = skill.name;
        await this.service.render();
    }

    public async sendAgent(question?: string) {
        const prompt = String(question || this.agentInput || '').trim();
        if (!prompt || this.agentLoading) return;

        this.agentOpen = true;
        this.agentStatus = '';
        this.agentMessages.push({ role: 'user', content: prompt });
        this.agentInput = '';
        this.resetAgentTextarea();
        this.agentLoading = true;
        this.saveAgentMessages();
        await this.service.render();
        this.scrollAgentToBottom();

        this.agentMessages.push({ role: 'assistant', content: '', sources: [], actions: [], skill: null, streaming: true });
        const assistantIdx = this.agentMessages.length - 1;
        await this.service.render();

        try {
            const formData = new FormData();
            formData.append('question', prompt);
            formData.append('current_path', this.selectedPath || '');
            formData.append('current_title', this.selectedTitle || '');
            formData.append('page_url', window.location.href || '');
            formData.append('headings', JSON.stringify(this.headings.map((heading: any) => ({ text: heading.text, level: heading.level }))));

            const appId = wiz.namespace || 'portal.gsdcuser.manual';
            this.agentAbortCtrl = new AbortController();
            const response = await fetch(`/wiz/api/${appId}/chat`, {
                method: 'POST',
                body: formData,
                signal: this.agentAbortCtrl.signal
            });

            if (!response.ok || !response.body) {
                throw new Error('Agent response failed');
            }

            const reader = response.body.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n\n');
                buffer = lines.pop() || '';

                for (const line of lines) {
                    if (!line.startsWith('data: ')) continue;
                    this.handleAgentEvent(JSON.parse(line.slice(6)), assistantIdx);
                }
            }
        } catch (error: any) {
            if (error.name === 'AbortError') {
                if (!this.agentMessages[assistantIdx].content) {
                    this.agentMessages[assistantIdx].content = '응답이 중지되었습니다.';
                }
            } else {
                this.agentMessages[assistantIdx].content = '응답 중 오류가 발생했습니다. 다시 시도해 주세요.';
            }
        }

        this.agentMessages[assistantIdx].streaming = false;
        this.agentLoading = false;
        this.agentAbortCtrl = null;
        this.agentMarkdownCache.clear();
        this.saveAgentMessages();
        if (this.destroyed) return;
        await this.service.render();
        this.scrollAgentToBottom();
        this.focusAgentInput();
    }

    public stopAgent() {
        if (this.agentAbortCtrl) {
            this.agentAbortCtrl.abort();
            this.agentAbortCtrl = null;
        }
    }

    public async askAgentSuggestion(question: string) {
        await this.sendAgent(question);
    }

    public onAgentKeyDown(event: KeyboardEvent) {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.sendAgent();
        }
    }

    public autoResizeAgentInput() {
        const element = this.agentInputArea?.nativeElement;
        if (!element) return;
        element.style.height = 'auto';
        element.style.height = Math.min(element.scrollHeight, 112) + 'px';
    }

    public renderAgentMarkdown(text: string): string {
        if (!text) return '';
        if (this.agentMarkdownCache.has(text)) return this.agentMarkdownCache.get(text)!;
        const html = this.converter ? this.converter.makeHtml(text) : this.escapeHtml(text);
        this.agentMarkdownCache.set(text, html);
        return html;
    }

    public async openAgentSource(src: any) {
        await this.executeAgentAction({
            kind: 'open_manual',
            label: '관련 매뉴얼 열기',
            payload: {
                source_id: src.id,
                title: src.title,
                path: src.path || '',
                candidate_paths: this.sourceCandidates(src)
            }
        }, true);
    }

    public async executeAgentAction(action: any, explicit: boolean = true) {
        if (!action || action.kind !== 'open_manual') return;
        if (!explicit && action.executed) return;
        action.executed = true;

        const candidates = this.actionCandidates(action);
        const item = this.findDocByCandidates(this.docs, candidates);
        if (!item) {
            this.agentStatus = '관련 문서를 목록에서 찾지 못했습니다.';
            await this.service.render();
            return;
        }

        this.expandParents(item.path);
        await this.selectDoc(item);
        this.agentStatus = action.mcp_tool ? `${action.mcp_tool} 실행: ${item.title}` : `${item.title} 문서로 이동했습니다.`;
        await this.service.render();
    }

    public async copyAgentAnswer(content: string) {
        try {
            const text = String(content || '')
                .replace(/#{1,4}\s+/g, '')
                .replace(/\*\*(.+?)\*\*/g, '$1')
                .replace(/\*(.+?)\*/g, '$1')
                .replace(/`([^`]+)`/g, '$1')
                .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1');
            await navigator.clipboard.writeText(text);
            this.agentStatus = '답변을 복사했습니다.';
            await this.service.render();
        } catch (error) {}
    }

    public async clearAgentChat() {
        this.agentMessages = [{ role: 'assistant', content: AGENT_WELCOME }];
        this.agentStatus = '';
        this.agentMarkdownCache.clear();
        this.saveAgentMessages();
        await this.service.render();
    }

    private handleAgentEvent(event: any, assistantIdx: number) {
        if (!event || this.destroyed) return;
        const message = this.agentMessages[assistantIdx];
        if (!message) return;

        if (event.type === 'token') {
            message.content += event.content || '';
            this.agentMarkdownCache.clear();
            this.cdr.detectChanges();
            this.scrollAgentToBottom();
            return;
        }

        if (event.type === 'replace') {
            const regex = new RegExp(event.pattern, 'g');
            message.content = message.content.replace(regex, event.replacement || '');
            this.agentMarkdownCache.clear();
            this.cdr.detectChanges();
            return;
        }

        if (event.type === 'skill') {
            message.skill = event.data;
            this.agentSelectedSkill = event.data?.name || this.agentSelectedSkill;
            this.cdr.detectChanges();
            return;
        }

        if (event.type === 'sources') {
            message.sources = event.data || [];
            this.cdr.detectChanges();
            return;
        }

        if (event.type === 'actions') {
            message.actions = event.data || [];
            this.cdr.detectChanges();
            for (const action of message.actions) {
                if (action.auto) window.setTimeout(() => this.executeAgentAction(action, false), 80);
            }
            return;
        }

        if (event.type === 'suggestions') {
            message.suggestions = event.data || [];
            this.cdr.detectChanges();
            return;
        }

        if (event.type === 'error') {
            message.content += `\n\n오류: ${event.message}`;
            this.cdr.detectChanges();
        }
    }

    private loadAgentMessages() {
        try {
            const storageKey = this.agentStorageKey();
            let raw = localStorage.getItem(storageKey);
            if (!raw && storageKey !== AGENT_STORAGE_PREFIX) {
                raw = localStorage.getItem(AGENT_STORAGE_PREFIX);
                if (raw) {
                    localStorage.setItem(storageKey, raw);
                    localStorage.removeItem(AGENT_STORAGE_PREFIX);
                }
            }
            if (raw) {
                const messages = JSON.parse(raw);
                if (Array.isArray(messages) && messages.length > 0) {
                    if (messages[0]?.role === 'assistant' && String(messages[0]?.content || '').indexOf('질문 예시') >= 0) {
                        messages[0].content = AGENT_WELCOME;
                    }
                    this.agentMessages = messages;
                    return;
                }
            }
        } catch (error) {}
        this.agentMessages = [{ role: 'assistant', content: AGENT_WELCOME }];
    }

    private saveAgentMessages() {
        try {
            const messages = this.agentMessages.map((message: any) => ({
                role: message.role,
                content: message.content,
                sources: message.sources || [],
                actions: message.actions || [],
                suggestions: message.suggestions || [],
                skill: message.skill || null
            }));
            localStorage.setItem(this.agentStorageKey(), JSON.stringify(messages));
        } catch (error) {}
    }

    private agentStorageKey(): string {
        const session = this.service.auth?.session || {};
        const userKey = session.id || session.email || session.account_name || '';
        if (!userKey) return AGENT_STORAGE_PREFIX;
        return `${AGENT_STORAGE_PREFIX}:${encodeURIComponent(String(userKey))}`;
    }

    private sourceCandidates(src: any): string[] {
        const id = String(src?.id || '').split('#', 1)[0];
        const candidates = [src?.path || '', id];
        if (id.indexOf('/') >= 0) candidates.push(id.split('/').slice(1).join('/'));
        return this.uniquePaths(candidates);
    }

    private actionCandidates(action: any): string[] {
        const payload = action?.payload || {};
        const candidates = []
            .concat(payload.candidate_paths || [])
            .concat([payload.path || '', payload.source_id || '']);
        const sourceId = String(payload.source_id || '').split('#', 1)[0];
        if (sourceId.indexOf('/') >= 0) candidates.push(sourceId.split('/').slice(1).join('/'));
        return this.uniquePaths(candidates);
    }

    private uniquePaths(paths: string[]): string[] {
        const result: string[] = [];
        for (const path of paths || []) {
            const normalized = this.normalizePath(path);
            if (normalized && result.indexOf(normalized) < 0) result.push(normalized);
        }
        return result;
    }

    private normalizePath(path: string): string {
        return String(path || '').split('#', 1)[0].replace(/\\/g, '/').replace(/^\/+|\/+$/g, '').normalize('NFC');
    }

    private findDocByCandidates(items: any[], candidates: string[]): any {
        const normalizedCandidates = (candidates || []).map((path: string) => this.normalizePath(path));
        for (const item of items || []) {
            if (item.type === 'file' && normalizedCandidates.indexOf(this.normalizePath(item.path)) >= 0) {
                return item;
            }
            const found = this.findDocByCandidates(item.children || [], normalizedCandidates);
            if (found) return found;
        }
        return null;
    }

    private requestedAgentDocument(): string {
        try {
            const params = new URLSearchParams(window.location.search || '');
            return this.normalizePath(params.get('agent_doc') || '');
        } catch (error) {
            return '';
        }
    }

    private updateAgentContext() {
        const context = {
            path: this.selectedPath || '',
            title: this.selectedTitle || '',
            headings: this.headings.map((heading: any) => ({ text: heading.text, level: heading.level }))
        };
        (window as any).GSDC_MANUAL_CONTEXT = context;
        (window as any).GSDC_MANUAL_OPEN_DOCUMENT = async (candidates: string[]) => {
            const item = this.findDocByCandidates(this.docs, candidates || []);
            if (!item) return false;
            this.expandParents(item.path);
            await this.selectDoc(item);
            return true;
        };
        window.dispatchEvent(new CustomEvent('gsdc-manual-context', { detail: context }));
    }

    private resetAgentTextarea() {
        const element = this.agentInputArea?.nativeElement;
        if (!element) return;
        element.value = this.agentInput || '';
        element.style.height = 'auto';
    }

    private scrollAgentToBottom() {
        try {
            const element = this.agentChatScroll?.nativeElement;
            if (!element) return;
            element.scrollTop = element.scrollHeight;
        } catch (error) {}
    }

    private focusAgentInput() {
        try {
            this.agentInputArea?.nativeElement?.focus();
        } catch (error) {}
    }

    private renderContent(content: string, mode: string) {
        let html = mode === 'markdown' ? this.converter.makeHtml(content) : '<pre>' + this.escapeHtml(content) + '</pre>';
        const container = document.createElement('div');
        container.innerHTML = html;

        // Keep every source heading and its anchor; only suppress the extra UI title.
        const first = container.firstElementChild;
        const normalizeTitle = (value: string) => value.normalize('NFC').trim().replace(/\s+/g, ' ').toLowerCase();
        this.hasDocumentTitle = first?.tagName === 'H1'
            && normalizeTitle(first.textContent || '') === normalizeTitle(this.displayTitle);

        const headings: any[] = [];
        const nodes = container.querySelectorAll('h1, h2, h3');
        nodes.forEach((node: any, index: number) => {
            const text = (node.textContent || '').trim();
            if (!text) return;
            const id = 'manual-heading-' + index;
            node.setAttribute('id', id);
            headings.push({ id: id, text: text, level: Number(String(node.tagName).replace('H', '')), index: index });
        });

        this.highlightContent(container, this.normalizeSearch(this.treeSearch));
        this.htmlContent = container.innerHTML;
        this.headings = headings;
        if (!this.headings.some((heading: any) => heading.id === this.activeHeadingId)) {
            this.activeHeadingId = '';
        }
    }

    private highlightContent(container: HTMLElement, keyword: string) {
        if (!keyword) return;

        const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
        const textNodes: Text[] = [];
        let node = walker.nextNode();
        while (node) {
            if (!this.isHighlightExcluded(node)) textNodes.push(node as Text);
            node = walker.nextNode();
        }

        for (const textNode of textNodes) {
            this.highlightTextNode(textNode, keyword);
        }
    }

    private scheduleContentHighlight() {
        window.setTimeout(() => { if (!this.destroyed) { this.highlightRenderedContent(); this.queueOutline(); } });
    }

    private highlightRenderedContent() {
        const element = this.markdownBody?.nativeElement;
        if (!element) return;
        this.highlightContent(element, this.normalizeSearch(this.treeSearch));
    }

    private isHighlightExcluded(node: Node): boolean {
        const parent = node.parentElement;
        if (!parent) return true;
        return !!parent.closest('script, style, textarea, input, select, option, mark.manual-content-match');
    }

    private highlightTextNode(textNode: Text, keyword: string) {
        const text = textNode.nodeValue || '';
        const normalized = text.normalize('NFC').toLowerCase();
        let index = normalized.indexOf(keyword);
        if (index < 0) return;

        const fragment = document.createDocumentFragment();
        let cursor = 0;
        while (index >= 0) {
            if (index > cursor) {
                fragment.appendChild(document.createTextNode(text.slice(cursor, index)));
            }

            const end = index + keyword.length;
            const mark = document.createElement('mark');
            mark.className = 'manual-content-match';
            mark.textContent = text.slice(index, end);
            fragment.appendChild(mark);

            cursor = end;
            index = normalized.indexOf(keyword, cursor);
        }

        if (cursor < text.length) {
            fragment.appendChild(document.createTextNode(text.slice(cursor)));
        }

        textNode.parentNode?.replaceChild(fragment, textNode);
    }

    private scrollManualTo(id: string) {
        const navigation = this.outlineNavigation;
        const heading = this.headings.find((item: any) => item.id === id);
        const nodes = this.markdownBody?.nativeElement?.querySelectorAll('h1, h2, h3');
        const element = heading && nodes?.[heading.index] as HTMLElement;
        if (!navigation || !element) { this.stopOutlineNavigation(false); return; }

        const root = this.readingScroller();
        navigation.root = root;
        const rootTop = root === document.documentElement ? 0 : root.getBoundingClientRect().top;
        const top = Math.max(0, Math.min(root.scrollHeight - root.clientHeight,
            root.scrollTop + element.getBoundingClientRect().top - rootTop - 14));
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        root.scrollTo({ top, behavior });

        const started = performance.now();
        let previous = root.scrollTop;
        let lastMoved = started;
        const finish = () => {
            if (this.destroyed || this.outlineNavigation !== navigation) return;
            const now = performance.now();
            const current = root.scrollTop;
            if (Math.abs(current - top) < 2) {
                navigation.settled = current;
                this.navigationFrame = 0;
                return;
            }
            if (Math.abs(current - previous) > .1) lastMoved = now;
            previous = current;
            // Recover tracking if scrolling was interrupted or layout changed mid-flight.
            if (now - lastMoved > 180 || now - started > 2500) {
                this.stopOutlineNavigation(false);
                this.queueOutline();
                return;
            }
            this.navigationFrame = window.requestAnimationFrame(finish);
        };
        this.navigationFrame = window.requestAnimationFrame(finish);
    }

    private escapeHtml(text: string): string {
        const div = document.createElement('div');
        div.appendChild(document.createTextNode(text || ''));
        return div.innerHTML;
    }

    private normalizeSearch(value: string): string {
        return String(value || '').normalize('NFC').toLowerCase().trim();
    }

    private applyTreeFilter() {
        const keyword = this.normalizeSearch(this.treeSearch);
        if (!keyword) {
            this.filteredDocs = this.withTitleParts(this.docs || [], keyword);
            return;
        }

        this.filteredDocs = (this.docs || [])
            .map((item: any) => this.filterTreeItem(item, keyword))
            .filter((item: any) => !!item);
    }

    private filterTreeItem(item: any, keyword: string): any {
        const title = this.normalizeSearch(item?.title || '');
        const path = this.normalizeSearch(item?.path || '');
        const children = (item?.children || [])
            .map((child: any) => this.filterTreeItem(child, keyword))
            .filter((child: any) => !!child);

        if (title.indexOf(keyword) >= 0 || path.indexOf(keyword) >= 0 || children.length > 0) {
            return { ...item, children: children, titleParts: this.createTitleParts(item.title, keyword) };
        }

        return null;
    }

    private withTitleParts(items: any[], keyword: string): any[] {
        return (items || []).map((item: any) => ({
            ...item,
            titleParts: this.createTitleParts(item.title, keyword),
            children: this.withTitleParts(item.children || [], keyword)
        }));
    }

    private createTitleParts(title: string, keyword: string): any[] {
        const text = String(title || '');
        if (!keyword) return [{ text: text, match: false }];

        const normalized = text.normalize('NFC').toLowerCase();
        const index = normalized.indexOf(keyword);
        if (index < 0) return [{ text: text, match: false }];

        const end = index + keyword.length;
        return [
            { text: text.slice(0, index), match: false },
            { text: text.slice(index, end), match: true },
            { text: text.slice(end), match: false }
        ].filter((part: any) => part.text.length > 0);
    }

    private findFirstFile(items: any[]): any {
        for (const item of items || []) {
            if (item.type === 'file') return item;
            const found = this.findFirstFile(item.children || []);
            if (found) return found;
        }
        return null;
    }

    private expandParents(path: string) {
        const parts = (path || '').split('/');
        let current = '';
        for (let index = 0; index < parts.length - 1; index++) {
            current = current ? current + '/' + parts[index] : parts[index];
            this.expanded[current] = true;
        }
    }

}

export default PortalGsdcuserManualComponent;